module.exports = __webpack_public_path__ + "static/media/IlotF_synthese_1.980db56e.webp";